import React from 'react';
import { Box, useTheme } from '@mui/material';
import ReportsMobileCard from '../common/ReportsMobileCard';
import CopyButton from '../common/CopyButton';
import { formatTimeToIST, formatDateAsSent } from '../../../utils/dateUtils';
import { formatPnlInr, formatRateInr } from './pnlFormatters';

// PnL rows as flat cards on phones. The API sends IST wall-clock times, so date
// and time are shown as sent, with no zone conversion.
const PnlHistoryMobileList = ({ pnlHistory }) => {
  const theme = useTheme();

  // Same rule as the desktop table: colour carries the sign, zero is neutral.
  const pnlColor = (value) => {
    const num = parseFloat(value);
    if (Number.isNaN(num) || num === 0) return theme.palette.text.secondary;
    return num > 0 ? theme.palette.success.main : theme.palette.error.main;
  };
  // Like the desktop table, a missing average reads as "-".
  const rate = (value) => (value > 0 ? formatRateInr(value) : '-');

  return (
    <Box
      sx={{
        p: 1,
        willChange: 'scroll-position',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {pnlHistory.map((item) => {
        const when = [formatDateAsSent(item.trade_time), formatTimeToIST(item.trade_time)]
          .filter(Boolean)
          .join(' · ');

        return (
          <ReportsMobileCard
            key={item.bill_id}
            lines={[
              {
                left: (
                  <>
                    {item.trading_symbol}
                    {item.exchange && (
                      <Box component="span" sx={{ color: 'text.secondary', fontWeight: 400 }}>
                        {' · '}{item.exchange}
                      </Box>
                    )}
                    {/* Qty belongs with the instrument, so it sits on the left too. */}
                    <Box component="span" sx={{ ml: 1.5, color: 'text.secondary', fontWeight: 400 }}>
                      Qty:{' '}
                      <Box component="span" sx={{ color: 'text.primary', fontWeight: 500 }}>{item.qty}</Box>
                    </Box>
                  </>
                ),
                right: { label: 'Buy', value: rate(item.buy_avg) },
              },
              {
                left: when || '-',
                right: { label: 'Sell', value: rate(item.sell_avg) },
              },
            ]}
            footer={`Bill ID: ${item.bill_id || '-'}`}
            footerAction={item.bill_id
              ? <CopyButton value={item.bill_id} label="bill ID" size="medium" />
              : null}
            footerActionInline
            footerRight={{
              label: 'P&L',
              value: formatPnlInr(item.realized_pnl),
              strong: true,
              color: pnlColor(item.realized_pnl),
            }}
          />
        );
      })}
    </Box>
  );
};

export default PnlHistoryMobileList;
